import * as React from "react";
import { observer } from "mobx-react";
import { ControlledCollapse } from "Components/Utils/ControlledCollapse";
import { QACommentItem } from "./QACommentItem";
import { AddCommentForm, SuggestionsConfig } from "./AddCommentForm";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cl from "classnames";

interface QQACommentsViewProps {
  data: API_Comment[];
  suggestions: SuggestionsConfig;
  onSubmit: (comment: string) => Promise<void>;
}

interface QACommentsViewState {
  isOpen: boolean;
}

interface CollapseHeaderProps extends WithTranslation {
  amount: number;
  isOpen: boolean;
  onClick: () => void;
}

const CollapseHeader = withTranslation(I18N_NS.PROJECT)(({ isOpen, onClick, amount, t }: CollapseHeaderProps) => {
  const className = cl("comment-collapse-icon", { open: isOpen });
  return (
    <a className="comment-collapse" onClick={onClick}>
      {amount === 1 ? <>{`1 ${t("comment")}`}</> : <>{`${amount} ${t("comments")}`}</>}
      <span style={{ fontSize: 12 }}>
        {isOpen ? t("Less") : t("More")}
        <FontAwesomeIcon className={className} style={{ marginLeft: 8 }} fixedWidth={true} icon={"chevron-down"} />
      </span>
    </a>
  );
});

export const QACommentsView = observer(
  class QACommentsView extends React.Component<QQACommentsViewProps, QACommentsViewState> {
    constructor(props: QQACommentsViewProps) {
      super(props);

      this.state = {
        isOpen: false,
      };
    }

    toggleCollapse = () => {
      this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
      const { data = [], onSubmit } = this.props;
      const { isOpen } = this.state;
      return (
        <div>
          <>
            <CollapseHeader onClick={this.toggleCollapse} amount={data.length} isOpen={isOpen} />
            <ControlledCollapse isOpen={isOpen}>
              <AddCommentForm onSubmit={onSubmit} suggestions={this.props.suggestions} />
              {data.map((item) => (
                <QACommentItem data={item} key={item.id} />
              ))}
            </ControlledCollapse>
          </>
        </div>
      );
    }
  }
);
